import _initialState from 'redux/initialState'
import {merge} from 'lodash'
import cookies from 'js-cookie'

const initialState = _initialState.apiAccess
let reducer = function(state = initialState, action) {

  switch (action.type) { //Use action type in switch
        case 'API_ACCESS__UPDATE':
            return merge({}, initialState, {value: action.payload}) // Reset to innitial store and store incoming access objects. 
        case 'API_ACCESS__ERROR':
            return merge({}, state, {error: action.payload}) // Preserve state and only update error object.
        case 'API_ACCESS__REMOVE':
            cookies.remove(action.payload)
            return state // Do not change anything. API_ACCESS__UPDATE will ge dispatched from the API_ACCESS__REMOVE action.
        default:
            return state // No change
    }
}

export default reducer